/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import React from 'react';
import moment from 'moment';
import { SalesService } from 'shared/services';
import {
    doorOneImage,
    doorTwoImage,
    doorThreeImage,
    image_thumbnail,
} from 'shared/images/images'

import {
    getCountDown,
    getDays,
    getDurationBgColor,
    getNumberDaysInWord,
    minTwoDigits,
    titleCase
} from 'shared/modifiers';
import * as momentTz from 'moment-timezone';

import './DoorView.scss';
import store from 'features/store';
/**


@Author Karthik

@param

@return door view html

**/

export class DoorView extends React.Component {

    constructor(props) {
        super(props);
        this.sale = props.sale;
        this.data = props.data

        this.saleContentRef = React.createRef(); // Sales content
        this.moreOptionsPopoverRef = React.createRef(); // More options popover ref
        this.desciptionPopoverRef = React.createRef(); //  Description popover ref
        this.desciptionScrollRef = React.createRef(); //  Description scroll ref
        this.desciptionRef = React.createRef(); // Desciption Ref
        this.titleRef = React.createRef(); // Title Ref

        this.expiration = moment.utc().local().add(30, 'seconds');
        this.lastItemsEnd = moment().utc().local();
        this.bgImage = [
            { bgImage: doorThreeImage, saleImages: `${process.env.PUBLIC_URL}/static/images/whoWeAre/Group 9158.png` },
            { bgImage: doorOneImage, saleImages: `${process.env.PUBLIC_URL}/static/images/whoWeAre/Group 9159.png` },
            { bgImage: doorTwoImage, saleImages: `${process.env.PUBLIC_URL}/static/images/whoWeAre/Group 9160.png` },
        ]
        this.state = {
            pageLoading: true,
            duration: moment.duration(moment().add(1, 'days').diff(moment())),

            bgImage: this.bgImage[props.config.index > 2 ? (props.config.index + 1) % 3 : props.config.index % 3],

            /* Door images inside to content align */
            contentHeight: this.props.doorImageDefaultHeight,
            contentWidth: 0,

            /* To handle responsive */
            innerWidth: window.innerWidth,

            /* Options popover */
            optionsPopoverShow: false,
            optionsPopoverTarget: false,
            disableOptionPopoverClose: false,

            /* Description popover */
            desciptionPopoverShow: false,
            desciptionPopoverTarget: false,
            disableDesciptionPopoverClose: false,
            desciptionScrollButtons: { disableTop: true, disableDown: false },

            /* Sale images list */
            saleImageList: [],
            categoryList: [],

            closeDaysText: 'Starts closing in',
            duration_bg_color: "normal",

            isSaleClosed: false,
            updatingTime: false,
            checkingItemCount: false,

            allItemsClosed: false
        };
        this.clearCountDown = null;

    }

    componentDidMount() {
        window.addEventListener('resize', this.setHeight);
        this.setState({
            ...this.state,
            pageLoading: false
        }, () => {
            this.countdown();
            this.getCloseDays();
            this.clearCountDown = setInterval(() => {
                this.countdown();
                this.getCloseDays();
                console.clear();
            }, 1000);

            setTimeout(() => {
                this.setHeight();
            }, 1000);
        });
    }

    componentDidUpdate() {
        window.addEventListener('resize', this.setHeight);
    }

    countdown = () => {
        const now = moment.utc();

        const saleEndtime = momentTz.tz(this.sale.endtime, this.sale.timezonename).utc();

        const isBefore = saleEndtime.isBefore(now);
        const endtime = isBefore ? this.lastItemsEnd : saleEndtime;

        const countdown = getCountDown(endtime, this.expiration, true, now);
        const countdownWithoutSecs = getCountDown(endtime, this.expiration, false, now);

        this.expiration = countdown.expiration;

        // Get bg color
        const duration_bg_color = getDurationBgColor(endtime, this.expiration);

        // Checking sale is closed
        const isSaleClosed = isNaN(countdownWithoutSecs.diffDuration.hours()) ? true : countdownWithoutSecs.diffDuration.hours() === 0 && countdownWithoutSecs.diffDuration.minutes() === 0 && countdownWithoutSecs.diffDuration.seconds() < 1;

        // Get last item end time
        if ( isBefore && !this.state.allItemsClosed && countdownWithoutSecs.diffDuration.days() === 0 && countdownWithoutSecs.diffDuration.hours() === 0 && countdownWithoutSecs.diffDuration.minutes() === 0 && countdownWithoutSecs.diffDuration.seconds() < 1 ) {
            // this.getCloseTime();
            if (!this.state.updatingTime) { this.setState({ updatingTime: true }, () => { this.getCloseTime(); this.getItemCount(); }); }
        }

        // Remove sale if both time are finished
        if (isBefore && countdown.isBefore && countdown.diffDuration.hours() === 0 && countdown.diffDuration.minutes() === 0 && countdown.diffDuration.seconds() < 2) {
            this.removeSale();
        }

        this.setState({
            ...this.state,
            duration: countdownWithoutSecs.diffDuration,
            duration_bg_color: duration_bg_color,
            isSaleClosed
        });
    }

    getCloseTime = () => {
        SalesService.getSaleClosingTime(this.sale.id).then(
            response => {
                const temp = response.data.data;
                if (temp.length > 0) {
                    this.lastItemsEnd = temp[0].itemclosetime;
                    if ( moment.utc(this.lastItemsEnd).isBefore(moment().utc()) ) {
                        this.setState({
                            allItemsClosed: true
                        });
                    }
                }
                setTimeout(() => {
                    this.setState({ updatingTime: false });
                }, 1000);
            }
        ).catch(error => {
            this.setState({ updatingTime: false });
            console.clear();
        });
    }

    getCloseDays = () => {
        const now = moment.utc();

        const saleEndtime = momentTz.tz(this.sale.endtime, this.sale.timezonename).utc();

        const isBefore = moment.utc(saleEndtime).isBefore(now);
        const endtime = isBefore ? this.lastItemsEnd : saleEndtime;

        const final = getNumberDaysInWord(endtime, this.expiration, true);

        const textValue = isBefore ? `Last item closes in` : final.final;

        this.setState({
            closeDaysText: textValue
        });
    }

    /* Called when screen size is change */
    setHeight = () => {
        try {
            this.setState({
                innerWidth: window.innerWidth
            }, () => {
                /*After responsice hanlde align content */
                setTimeout(() => {
                    try {
                        const content = [this.saleContentRef.current];
                        const contentHeight = content.length > 0 ? content[0].clientHeight + 86 : this.props.doorImageDefaultHeight;
                        const contentWidth = content.length > 0 ? content[0].clientWidth : 0;
                        store.dispatch({ type: 'SET_DOOR_HEIGHT', payload: contentHeight });
                        this.setState({
                            contentHeight: contentHeight,
                            contentWidth: contentWidth
                        });
                    } catch (e) {
                        console.error(e);
                    }
                });
            });
        } catch (e) {
            console.error(e);
        }
    }

    navigate = () => {
        this.props.navigate(this.sale);
    }

    /* Called when more options button hover */
    moreOptionsPopoverHanlde = (event, flag) => {

        /* Mouse enter */
        if (event.type === "mouseenter") {
            if (flag === 'Popover-Div') {
                this.setState({ disableOptionPopoverClose: true });
            } else {
                this.setState({ optionsPopoverShow: true, optionsPopoverTarget: event.target });
            }
        }

        /** Mouse Leave */
        else if (event.type === "mouseleave") {
            if (flag === 'Popover-Div') {
                this.setState({ disableOptionPopoverClose: false });
            }
            setTimeout(() => {
                if (!this.state.disableOptionPopoverClose) {
                    this.setState({ optionsPopoverShow: false });
                }
            }, 1500);
        }
    }

    /* Called when title button hover */
    desciptionPopoverHanlde = (event, flag) => {

        /* Mouse enter */
        if (event.type === "mouseenter") {
            if (flag === 'Popover-Div') {
                this.setState({ disableDesciptionPopoverClose: true });
            } else {
                this.setState({ desciptionPopoverShow: true, desciptionPopoverTarget: event.target });
            }
        }

        /** Mouse Leave */
        else if (event.type === "mouseleave") {
            if (flag === 'Popover-Div') {
                this.setState({ disableDesciptionPopoverClose: false });
            }
            setTimeout(() => {
                if (!this.state.disableDesciptionPopoverClose) {
                    this.setState({ desciptionPopoverShow: false });
                }
            }, 1500);
        }
    }

    /**
     * Called when up or down button click
     * 
     * @param {string} direction Either Up or Down
     * 
     */
    desciptionScrollHandle = (event, direction) => {
        event.stopPropagation();
        /* Scroll up or down with animation */
        direction === 'Down' ? this.desciptionScrollRef.current.scrollTo({
            top: (this.desciptionScrollRef.current.scrollTop + 150),
            behavior: 'smooth'
        }) : this.desciptionScrollRef.current.scrollTo({
            top: (this.desciptionScrollRef.current.scrollTop - 150),
            behavior: 'smooth'
        });

        /* Disable buttons based on scroll */
        setTimeout(() => {
            const scrollContent = this.desciptionScrollRef.current;
            this.setState({
                desciptionScrollButtons: {
                    disableTop: scrollContent.scrollTop === 0,
                    disableDown: scrollContent.clientHeight <= scrollContent.scrollTop
                }
            });
        }, 500);

    }

    titlePopoveShowAndHide = () => {
        const element = this.titleRef.current;
        return element ? element.offsetHeight < element.scrollHeight : false;
    }

    desciptionPopoverShowAndHide = () => {
        const element = this.desciptionRef.current;
        return element ? element.offsetHeight < element.scrollHeight : false;
    }

    removeSale = () => {
        if (this.props.removeSale) {
            this.props.removeSale();
        }
    }

    aTagHandle = (event) => {
        event.preventDefault();
    }

    getItemCount = () => {
        setTimeout(() => {
            this.setState({
                checkingItemCount: true
            }, () => {
                const saleDetailData = {
                    "field": ["id", "title", "itemcount"],
                    "filter": [{ "field": "id", "value": this.sale.id, "op": "=", "join": "AND" }],
                };
                SalesService.getSalesList(saleDetailData).then(
                    res => {
                        this.sale.itemcount = res.data.data[0].itemcount;
                        this.setState({ checkingItemCount: false });
                    }
                ).catch(error => {
                    console.error(error);
                });
            });
        }, 10000);
    }

    componentWillUnmount() {
        if ( this.clearCountDown ) {
            clearInterval(this.clearCountDown);
        }
        window.removeEventListener('resize', this.setHeight);
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        return (
            <div className={`${this.props.className ? this.props.className : ''}`}>
                {
                    this.state.pageLoading ? null :
                        <div className="image-content">
                            <img src={!this.data ? this.state.bgImage.bgImage : null}  alt={!this.data ? "closes-in-x"  : '' } className={`clickable ${!this.data ? 'bg-image' : ''}`}  style={{ height: this.state.contentHeight > 0 ? `${this.state.contentHeight}px` : 'unset' }} onClick={this.navigate}></img>
                            <div className="sale-content clickable"  style={{ border : this.data ? '1px solid #9f2241' : '' }} ref={this.saleContentRef} onClick={this.navigate} >
                                {/*  */}
                                <a href={`/estate-sale/${this.sale.id}`} aria-label={this.sale.title} className="remain-space" onClick={this.aTagHandle}>
                                    <div className={`duration ${this.state.duration_bg_color}`}>
                                        <div className="days">
                                            {this.state.isSaleClosed || this.state.updatingTime ? null : this.state.closeDaysText}
                                        </div>
                                        {
                                            this.state.updatingTime ? <div className="closed danger">
                                                Checking Closing Time
                                            </div> :
                                                this.state.isSaleClosed ?
                                                    <div className="closed danger">
                                                        Sale Closed
                                                    </div> :
                                                    <div className="count">
                                                        <div className="day">
                                                            {/* <div className="word">DAYS</div> */}
                                                            <div className="num">
                                                                <span>{minTwoDigits(getDays(this.state.duration.asDays()))}</span>d
                                                            </div>
                                                        </div>
                                                        <div className="hr">
                                                            {/* <div className="word">HRS</div> */}
                                                            <div className="num">
                                                                <span>{minTwoDigits(this.state.duration.hours())}</span>h
                                                            </div>
                                                        </div>
                                                        <div className="min">
                                                            {/* <div className="word">MIN</div> */}
                                                            <div className="num">
                                                                <span>{minTwoDigits(this.state.duration.minutes())}</span>m
                                                            </div>
                                                        </div>
                                                        <div className="sec">
                                                            {/* <div className="word">SEC</div> */}
                                                            <div className="num">
                                                                <span>{minTwoDigits(this.state.duration.seconds())}</span>s
                                                            </div>
                                                        </div>
                                                    </div>
                                        }
                                    </div>
                                    <div className="content-header d-flex align-items-center justify-content-center">
                                        {/* <div className={`content-header-title mx-7 ${this.titlePopoveShowAndHide() ? '' : 'd-flex align-items-center justify-content-center'}`} ref={this.titleRef}>{this.sale.title}</div>
                                    <OverlayTrigger
                                        trigger={['hover', 'focus']}
                                        placement="bottom-end"
                                        overlay={
                                            <Popover id={`popover-contained-`} className="popover-style mx-7" style={{ width: this.state.contentWidth + 4 }}>
                                                <Popover.Content className="options-text-body">
                                                    <div className="sale-title">Sale title</div>
                                                    <div className="items-details">{this.sale.title}</div>
                                                </Popover.Content>
                                            </Popover>
                                        }
                                    >
                                        <span className={`dot mr-15 ${this.titlePopoveShowAndHide() ? '' : 'd-none'}`}></span>
                                    </OverlayTrigger> */}

                                        <div className={`content-header-title mx-7 ${this.titlePopoveShowAndHide() ? '' : 'd-flex align-items-center justify-content-center'}`} ref={this.titleRef}>{this.sale.title}</div>

                                    </div>
                                    <div className="d-flex justify-content-center">
                                        <div className={`sale-image-container ${!this.sale.saleimageurl ? 'no-image' : ''} d-flex align-items-center justify-content-center`}>
                                            <img src={this.sale.saleimageurl} alt="item-image" onLoad={() => { this.setHeight() }} key={`sale_image`} className={`sale-image ${!this.sale.saleimageurl ? 'no-image' : ''}`}></img>
                                        </div>
                                    </div>
                                    <div className="text-center image-bottom">
                                        {this.state.isSaleClosed && !this.state.updatingTime ? 0 : this.sale.itemcount} Items
                                    </div>
                                    <div className="content-text">
                                        <div className={`description ${this.desciptionPopoverShowAndHide() ? '' : ''}`} ref={this.desciptionRef}>
                                            {this.sale.provenance}
                                        </div>
                                        {/* <div className="title-popover" ref={this.desciptionPopoverRef}>
                                        <div className={`dot ${this.desciptionPopoverShowAndHide() ? 'visible' : 'invisible'}`}
                                            onMouseEnter={(event) => { this.desciptionPopoverHanlde(event, 'Main-Div') }}
                                            onMouseLeave={(event) => { this.desciptionPopoverHanlde(event, 'Main-Div') }}></div>
                                        <Overlay
                                            target={this.state.desciptionPopoverTarget}
                                            container={this.desciptionPopoverRef.current}
                                            placement="top-end"
                                            show={this.state.desciptionPopoverShow}
                                        >
                                            <Popover id="popover-contained" className="popover-style" style={{ width: this.state.contentWidth + 4 }}
                                                onMouseEnter={(event) => { this.desciptionPopoverHanlde(event, 'Popover-Div') }}
                                                onMouseLeave={(event) => { this.desciptionPopoverHanlde(event, 'Popover-Div') }}>
                                                <Popover.Content className="title-text-body d-flex flex-column align-items-center">
                                                    <div className={`scroll-button-top ${this.state.desciptionScrollButtons.disableTop ? 'disabled' : 'clickable'}`} onClick={(event) => { this.desciptionScrollHandle(event, 'Up') }}>
                                                        <i className="fas fa-chevron-up"></i>
                                                    </div>
                                                    <div className="scroll-content" ref={this.desciptionScrollRef}>
                                                        <h3>Sale title</h3>
                                                        <div>
                                                            {this.sale.provenance}
                                                        </div>
                                                    </div>
                                                    <div className={`scroll-button-down ${this.state.desciptionScrollButtons.disableDown ? 'disabled' : 'clickable'}`} onClick={(event) => { this.desciptionScrollHandle(event, 'Down') }}>
                                                        <i className="fas fa-chevron-down"></i>
                                                    </div>
                                                </Popover.Content>
                                            </Popover>
                                        </Overlay>
                                    </div> */}
                                    </div>

                                    {/* <div className="options d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center justify-content-center">
                                        {
                                            this.state.categoryList[0] ?
                                                <div className="button">{this.state.categoryList[0].category}</div> : null
                                        }
                                        {/* <div className="button">{this.state.categoryList[0].category}</div> 
                                        {
                                            this.state.innerWidth > 1023 && this.state.categoryList[1] ?
                                                <div className="button">{this.state.categoryList[1].category}</div> : null
                                        }
                                        {
                                            this.state.innerWidth > 1365 && this.state.categoryList[2] ?
                                                <div className="button">{this.state.categoryList[2].category}</div>
                                                : null
                                        }
                                    </div>
                                    <div className="options-popover" ref={this.moreOptionsPopoverRef}>
                                        <div className="dot"
                                            onMouseEnter={(event) => { this.moreOptionsPopoverHanlde(event, 'Main-Div') }}
                                            onMouseLeave={(event) => { this.moreOptionsPopoverHanlde(event, 'Main-Div') }}></div>
                                        <Overlay
                                            target={this.state.optionsPopoverTarget}
                                            container={this.moreOptionsPopoverRef.current}
                                            placement="top-end"
                                            show={this.state.optionsPopoverShow}
                                        >
                                            <Popover id="popover-contained" className="popover-style" style={{ width: this.state.contentWidth + 4 }}
                                                onMouseEnter={(event) => { this.moreOptionsPopoverHanlde(event, 'Popover-Div') }}
                                                onMouseLeave={(event) => { this.moreOptionsPopoverHanlde(event, 'Popover-Div') }}>
                                                <Popover.Content className="options-text-body">
                                                    <div className="d-flex flex-wrap">
                                                        {
                                                            this.state.categoryList.map((category, index) => {
                                                                return (index > 2 ? <div className="button" key={`options_key_${index}`}>{category.category}</div> : null)
                                                            })
                                                        }
                                                    </div>
                                                </Popover.Content>
                                            </Popover>
                                        </Overlay>
                                    </div>
                                </div> */}
                                    <div className="bottom d-flex align-items-center justify-content-between">
                                        <div className="left-content auto-captitalize" >{titleCase(this.sale.city)}, {titleCase(this.sale.state)}, {this.sale.zipcode}</div>
                                        <div className="right-content clickable d-flex align-items-center justify-content-center" onClick={this.navigate}>
                                            <i className="fas fa-long-arrow-alt-right"></i>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                }
            </div>
        );
    }

}